import { useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OfflineDetector = () => {

  useEffect(() => {
    let lastStatus = navigator.onLine;

    const updateOnlineStatus = () => {
      const currentStatus = navigator.onLine;
      
      // Only trigger if status has actually changed
      if (currentStatus === lastStatus) return;
      
      lastStatus = currentStatus;
      
      if (currentStatus) {
        toast.success('You are back online!', {
          toastId: 'online-toast',
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        toast.error('You are offline. Some features may be unavailable.', {
          toastId: 'offline-toast',
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default OfflineDetector;